/**
 * Done. / ChiroCPD — LockoutBanner
 *
 * Shown when subscription is inactive/cancelled/past_due.
 * Sticky top-0 z-50, role="alert", NOT dismissible.
 * data-print-hidden so it doesn't appear in print/export.
 */



interface LockoutBannerProps {
  resubscribeUrl: string;
}

export function LockoutBanner({ resubscribeUrl }: LockoutBannerProps): React.ReactElement {
  return (
    <div
      role="alert"
      aria-live="assertive"
      data-print-hidden
      className="sticky top-0 z-50 w-full bg-[var(--color-error-500)] text-white px-4 py-3"
    >
      <div className="mx-auto max-w-5xl flex flex-col sm:flex-row items-start sm:items-center gap-3 justify-between">
        <p className="text-sm font-medium">
          <strong>Your Done. CPD subscription is inactive.</strong>{' '}
          Your data is safe. Resubscribe to restore full access.
        </p>
        <a
          href={resubscribeUrl}
          className="shrink-0 rounded-[var(--radius-md)] bg-white px-4 py-2 text-sm font-semibold text-red-700 hover:bg-red-50 min-h-[44px] inline-flex items-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-red-600"
        >
          Resubscribe — $85/month
        </a>
      </div>
    </div>
  );
}


